import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ScoringLoader from 'general/js/loaders/scoring-loader';
import { BlockPlaceholder } from 'components/block-placeholder';
import { BlockSpinner } from 'components/block-spinner';
import QualEventItem from './qual-events-item';

class QualEventsContainer extends React.Component {
    componentDidMount() {
        ScoringLoader.subscribe(`summary${this.props.options.type}`);
    }

    componentWillUnmount() {
        ScoringLoader.unsubscribe(`summary${this.props.options.type}`);
    }

    render() {
        var { scoringSummary } = this.props;
        if (scoringSummary === undefined) {
            return (
                <BlockPlaceholder minHeight={150}>
                    <BlockSpinner />
                </BlockPlaceholder>
            );
        }

        if (!scoringSummary || !Array.isArray(scoringSummary.locations)) return null;

        scoringSummary.locations = sortAlfa(scoringSummary.locations);

        return (
            <ul className="qual-events__cards-list">
                {
                    scoringSummary.locations.map((location) =>
                        <QualEventItem key={location.locationId} location={location} />)
                }
            </ul>
        );
    }
}

QualEventsContainer.propTypes = {
    options: PropTypes.object
};

const mapStateToProps = (state, ownProps) => ({
    scoringSummary: state.scoring[`summary${ownProps.options.type}`]
});

const sortAlfa = (locations) =>
{
    return [...locations].sort((a,b)=>{
        if (a.sitecoreData && b.sitecoreData) {
        return a.sitecoreData.name.localeCompare(b.sitecoreData.name)
    }
});
};

const QualEventsContainerWrapper = connect(
    mapStateToProps
)(QualEventsContainer);

export default QualEventsContainerWrapper;
